<template>
  <div class="contain padc">
    <div class="layout-desc-check">
      <div class="content-desc-check">
        <div class="ele-addvisit"><span class="label-add-visit">客户中文名称</span><input type="text"
                 placeholder="请输入客户中文名称"
                 class="text-addvisit"
                 v-model="customer.name"
                 @blur="searchCustData"><span style="padding-left:0.1rem"
                v-show='customer.name!=""'
                @click="searchCustData"><img src="../../assets/images/icon-search.png"></span></div>

        <div class="ele-addvisit"><span class="label-add-visit">行业</span><input type="text"
                 placeholder="请选择行业"
                 class="text-addvisit"
                 readonly
                 @click="showPopup(0,pickerSet)"
                 v-model="trade.txt"></div>

        <div class="ele-addvisit"><span class="label-add-visit">公司性质</span><input type="text"
                 placeholder="请选择公司性质"
                 class="text-addvisit"
                 readonly
                 @click="showPopup(1,pickerSet)"
                 v-model="companyType.txt"></div>

        <div class="ele-addvisit"><span class="label-add-visit">投资国/地区</span><input type="text"
                 placeholder="请选择投资国/地区"
                 class="text-addvisit"
                 readonly
                 @click="showPopup(2,pickerSet)"
                 v-model="nationality.txt"></div>
        <div class="ele-addvisit"><span class="label-add-visit">地址</span><input type="text"
                 placeholder="请输入客户地址"
                 class="text-addvisit"
                 v-model="customer.address"
                 readonly
                 @click="showMap()"></div>

        <div class="ele-addvisit"><span class="label-add-visit">电话</span><input type="text"
                 placeholder="请输入客户电话"
                 class="text-addvisit"
                 v-model="customer.tel"></div>

        <div class="ele-addvisit"><span class="label-add-visit">信息来源</span><input type="text"
                 placeholder="请选择信息来源"
                 class="text-addvisit"
                 readonly
                 @click="showPopup(3,pickerSet)"
                 v-model="source.txt"></div>
        <div class="ele-addvisit"><span class="label-add-visit">客户类型</span><input type="text"
                 placeholder="请选择客户类型"
                 class="text-addvisit"
                 readonly
                 @click="showPopup(8,pickerSet)"
                 v-model="custType.txt"></div>
      </div>
    </div>
    <!--模块-->
    <div class="layout-desc-check">
      <div class="content-desc-check">
        <div class="ele-addvisit"><span class="label-add-visit">销售员</span><span class="info-desc-check">{{this.salesName}}</span></div>
        <!--元素-->
        <!-- <div class="ele-addvisit noborderb"><span class="label-add-visit">部门</span>
          <div class="content-sel-addvisit"><input type="text"
                   class="text-addvisit"
                   readonly></div>
        </div> -->
        <!--元素-->
      </div>
    </div>
    <!--模块-->
    <div class="layout-desc-check">
      <div class="tit-desc-check color-nol">联系人</div>
      <div class="content-desc-check cotent-contact-check"
           v-for="p in connecter.data"
           :key="p.tempId">
        <div @click="showConnecter(p.tempId)">
          <div class="ele-desc-check"><span class="label-desc-check">姓名</span><span class="info-desc-check">{{p.name}}</span></div>
          <div class="ele-desc-check"><span class="label-desc-check">三名片</span><span class="info-desc-check">{{p.cardTxt}}</span></div>
          <div class="ele-desc-check"><span class="label-desc-check">电话</span><span class="info-desc-check">{{p.tel}}</span></div>
          <div class="ele-desc-check"><span class="label-desc-check">负责人</span><span class="info-desc-check">{{p.salTxt}}</span></div>
        </div>
        <div class="ele-desc-check">
          <button class="del-desc-check btnCenter"
                  @click="deleteConnecter(p.tempId)">删除</button>
        </div>
      </div>
      <div style="padding-bottom:1rem">
        <a href="#"
           class="link-add-contact"
           @click="showConnecter(connAdd)"><img src="../../assets/images/icon-add.png"
               class="icons-add-contact"><span>添加联系人</span></a>
      </div>
    </div>
    <!--模块-->
    <div v-show="submitShow"
         class="content-btn-check">
      <button class="chancel-desc-check widthmax"
              @click="cancel">取消</button>
      <button class="sure-desc-check widthmax"
              @click="submit">提交</button>
    </div>
    <van-popup v-model="pop.show"
               round
               :position="pop.location"
               :style="{ height: pop.popHeight }">
      <van-picker v-show="pop.showCom==pickerSet"
                  :title="pop.title"
                  show-toolbar
                  :columns="pop.list"
                  :confirm-button-text="pop.confirmTxt"
                  :cancel-button-text="pop.cancelTxt"
                  @confirm="onPopConfirm"
                  @cancel="hidePopup"></van-picker>
      <van-datetime-picker v-show="pop.showCom==timePickerSet"
                           v-model="timePicker.currentDate"
                           type="date"
                           :title="timePicker.title"
                           :min-date="timePicker.minDate"
                           :max-date="timePicker.maxDate"
                           @confirm="timePickerConfirm"
                           @cancel="hidePopup" />
    </van-popup>
    <van-popup v-model="popConn.show"
               :style="{ height: popConn.popHeight }">
      <div class="contain">
        <div class="layout-desc-check">
          <div class="content-desc-check">
            <div class="ele-addvisit"><span class="label-add-visit">联系人姓名</span><input type="text"
                     placeholder="请输入联系人姓名"
                     class="text-addvisit"
                     v-model="connecter.name"
                     required></div>
            <div class="ele-addvisit"><span class="label-add-visit">性别</span><input type="text"
                     placeholder="请选择性别"
                     class="text-addvisit"
                     readonly
                     @click="showPopup(6,pickerSet)"
                     v-model="sex.txt"
                     required></div>

            <!-- <div class="ele-addvisit"><span class="label-add-visit">生日</span><input type="text"
                     placeholder="请选择生日"
                     class="text-addvisit"
                     readonly
                     @click="showPopup(7,timePickerSet)"
                     v-model="connecter.birthday"
                     required></div> -->
            <!--元素-->

            <div class="ele-addvisit"><span class="label-add-visit">三名片</span><input type="text"
                     placeholder="请选择三名片"
                     class="text-addvisit"
                     readonly
                     @click="showPopup(4,pickerSet)"
                     v-model="card.txt"
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">职务</span><input type="text"
                     placeholder="请输入职务"
                     class="text-addvisit"
                     v-model="connecter.position"
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">电话</span><input type="text"
                     placeholder="请输入联系人电话"
                     class="text-addvisit"
                     v-model="connecter.tel"
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">就职状态</span><input type="text"
                     placeholder="请选择就职状态"
                     class="text-addvisit"
                     readonly
                     @click="showPopup(5,pickerSet)"
                     v-model="status.txt"
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">负责人</span><input type="text"
                     placeholder="请输入姓名/编号搜索"
                     class="text-addvisit"
                     v-model="salesman.txt"
                     required><span style="padding-left:0.1rem"
                    v-show='salesman.txt!=""'
                    @click="searchSalesman"><img src="../../assets/images/icon-search.png"></span></div>
          <div class="ele-addvisit noborderb"
               style="padding-top:0.24rem"><button class="chancel-desc-check"
                    @click="hideConnecter">取消</button>
            <button class="sure-desc-check"
                    @click="saveConnecter">保存</button>
          </div>
        </div>
      </div>
      <!--模块-->

      <!-- <div v-show="submitShow"
             class="content-btn-check"
             style="border-top:0">
          <button class="chancel-desc-check"
                  style="width:30%"
                  @click="hideConnecter">取消</button>
          <button class="sure-desc-check"
                  style="width:30%"
                  @click="saveConnecter">保存</button>
        </div> -->
  </div>
  </van-popup>

  <van-popup v-model="popReCust.show"
             :style="{ height: popReCust.popHeight}">
    <div class="contain">
      <div class="layout-desc-check">
        <div class="content-desc-check">
          <div class="ele-addvisit"><span class="label-add-visit"
                  style="width: 1.44rem">客户名称</span><span type="text"
                  placeholder="客户名称">{{this.customer.reCustomer.name}}</span></div>
          <div class="ele-addvisit"><span class="label-add-visit">销售员</span><span type="text"
                  placeholder="销售员">{{this.customer.reCustomer.salseName}}</span></div>
          <div class="ele-addvisit"><span class="label-add-visit">部门</span><span type="text"
                  placeholder="部门">{{this.customer.reCustomer.branch}}</span></div>
        </div>
        <div class="ele-addvisit noborderb"
             style="padding-top:0.98rem">
          <button class="sure-desc-check widthmax"
                  @click="closeReCustInfo">关闭</button>
        </div>
      </div>
    </div>
  </van-popup>

  <van-popup v-model="popMap.show"
             :style="{ height: popMap.popHeight,width:'90%'}">
    <TencentMap :search="customer.name"
                        v-if="popMap.show"></TencentMap>
  </van-popup>
  </div>
</template>
<script>
import TencentMap from '../../components/checkin/TencentMap.vue'
import customerModel from '../../api/model/customer'
import clueModel from '../../api/model/clue'
import globParamModel from '../../api/model/glob-param'
import salesmanModel from '../../api/model/salesman'
// import smsModel from '../../api/model/sms'
import { mapState } from 'vuex'
import { nanoid } from 'nanoid'
export default {
  name: 'CustomerInfo',
  props: ['id', 'clue'],
  components: {
    TencentMap,
  },
  data() {
    return {
      //系统参数
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      submitShow: true, //提交按钮显示
      pickerSet: 'pickerSet', //选择器
      timePickerSet: 'timePickerSet', //时间选择器
      connAdd: 'connAdd',
      //客户信息
      customer: {
        name: '', //客户名称
        address: '', //地址
        lng: '', //经度
        lat: '', //纬度
        tel: '', //电话
        data: [], //通过API模糊查询的客户数据
        list: [], //POP下拉数据
        checkPass: false, //是否校验通过
        reCustomer: {
          //api查出的重复数据
          name: '', //客户名称
          salseName: '', //销售员名称
          branch: '', //部门名称
        },
      },
      timePicker: {
        minDate: new Date(1949, 9, 1),
        maxDate: new Date(),
        currentDate: new Date(2021, 0, 17),
        title: '请选择生日',
      },
      //下拉弹出
      pop: {
        show: false, //是否显示POP
        operType: 0, //POP类型 根据类型不同显示不同数据 具体类型看上面template
        title: '', //POP标题
        list: [], //POP下拉数据
        location: 'bottom', //POP展示位置
        popHeight: '35%', //高度
        showCom: this.pickerSet,
        confirmTxt: '',
        cancelTxt: '',
      },
      popConn: {
        show: false, //是否显示POP
        operType: 0, //POP类型 根据类型不同显示不同数据 具体类型看上面template
        title: '', //POP标题
        list: [], //POP下拉数据
        popHeight: '60%', //高度
      },
      popReCust: {
        show: false, //是否显示POP
        operType: 0, //POP类型 根据类型不同显示不同数据 具体类型看上面template
        title: '', //POP标题
        list: [], //POP下拉数据
        popHeight: '35%', //高度
      },
      popMap: {
        show: false, //是否显示POP
        operType: 0, //POP类型 根据类型不同显示不同数据 具体类型看上面template
        title: '', //POP标题
        list: [], //POP下拉数据
        popHeight: '80%', //高度
      },
      //行业
      trade: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //所选代码值
        txt: '', //所选显示文字
      },
      //数据来源
      source: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //所选代码值
        txt: '', //所选显示文字
      },
      //投资国/地区
      nationality: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //所选代码值
        txt: '', //所选显示文字
      },
      //企业类型
      companyType: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //所选代码值
        txt: '', //所选显示文字
      },
      //联系人
      connecter: {
        tempId: '',
        num: 0, //添加数量
        data: [], //添加的联系人数据
        name: '', //联系人名称
        position: '', //联系人职务
        tel: '', //联系人电话
        birthday: '', //生日
        sal: '', //负责人
      },
      //三名片
      card: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //三名片代码
        txt: '', //三名片文字
      },
      //就职状态
      status: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //在职状态代码
        txt: '', //在职状态文字
      },
      //性别
      sex: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //性别代码
        txt: '', //性别文字
      },
      //客户类型
      custType: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //所选代码值
        txt: '', //所选显示文字
      },
      //销售员
      salesman: {
        data: [], //API数据
        list: [], //下拉数据
        code: '', //所选代码值
        txt: '', //所选显示文字
      },
    }
  },
  methods: {
    init() {
      if (this.clue > 0) {
        this.getClueBaseInfo()
      }
      this.timePickerInit()
      this.getTrade()
      this.getSource()
      this.getNationality()
      this.getCompanyType()
      this.getGetCard()
      this.getGetJobStatus()
      this.getGetSex()
      this.getCustType()
      this.$bus.$on('setLocation', this.setLocation)
      window.onresize = () => {
        return (() => {
          this.showHeight = document.body.clientHeight
        })()
      }
    },
    async getClueBaseInfo() {
      var res = await clueModel.getClueBaseInfo({ id: this.clue })
      if (res.success) {
        this.customer.name = res.data.customerName
      } else {
        this.$toast(res.msg)
      }
    },
    cancel() {
      this.$router.push({ path: '/home' })
    },
    checkCustnameChar() {
      var reg = /[0-9a-z]/i
      if (this.customer.name.match(reg) != null) {
        return false
      }
      return true
    },
    async submit() {
      if (this.customer.name == '') {
        this.$toast('请输入客户名称')
      } else if (!this.checkCustnameChar()) {
        this.$toast('客户名称不能包含字母和数字')
      } else if (!this.customer.checkPass) {
        this.$toast(
          '部门内已存在与' +
            this.customer.name +
            '名称类似的客户，请建立客户小组或修改客户名称'
        )
      } else if (this.trade.code == '') {
        this.$toast('请选择行业')
      } else if (this.companyType.code == '') {
        this.$toast('请选择公司性质')
      } else if (this.nationality.code == '') {
        this.$toast('请选择投资国/地区')
      } else if (this.customer.address == '') {
        this.$toast('请选择地址')
      } else if (this.customer.tel == '') {
        this.$toast('请输入电话')
      } else if (this.source.code == '') {
        this.$toast('请选择信息来源')
      } else if (this.custType.code == '') {
        this.$toast('请选择客户类型')
      } else if (this.connecter.num <= 0) {
        this.$toast('请添加至少一个联系人')
      } else {
        const connData = []
        this.connecter.data.forEach((p) => {
          const conn = {
            name: p.name,
            sex: p.sex,
            birthday: p.birthday,
            card: p.card,
            position: p.position,
            tel: p.tel,
            status: p.status,
            sal:p.sal
          }
          connData.push(conn)
        })
        var res
        if (this.id == 0) {
          res = await customerModel.addCustomer(
            {
              address: this.customer.address,
              companyType: this.companyType.code,
              fax: '0',
              trade: this.trade.code,
              nationality: this.nationality.code,
              customerName: this.customer.name,
              source: this.source.code,
              tel: this.customer.tel,
              zip: '0',
              connecter: connData,
              custType: this.custType.code,
              latitude: this.customer.lat,
              longitude: this.customer.lng,
              clueId: this.clue,
            },
            null
          )
        } else {
          this.$toast('这是编辑')
        }
        if (res.success) {
          this.$toast('客户信息提交成功')
          // var msgRes = await smsModel.sendApproveMessage(null, {
          //   type: this.approveParam.customer,
          // })
          // if (msgRes.success) {
          //   this.$toast('客户信息提交成功')
          // } else {
          //   this.$toast('客户信息提交成功,短信发送失败')
          // }
          this.$router.push({ path: '/home' })
        } else {
          this.$toast(res.msg)
        }
      }
    },
    timePickerInit() {
      var dateTime = new Date()
      this.timePicker.maxDate = new Date(
        dateTime.getFullYear() - 18,
        dateTime.getMonth(),
        dateTime.getDate()
      )
      this.timePicker.currentDate = new Date(dateTime.getFullYear() - 25, 0, 1)
    },
    formatCalendarDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    timePickerConfirm(date) {
      this.connecter.birthday = this.formatCalendarDate(date)
      this.hidePopup()
    },
    deleteConnecter(id) {
      for (let index = 0; index < this.connecter.data.length; index++) {
        if (this.connecter.data[index].tempId == id) {
          this.connecter.data.splice(index, 1)
          this.connecter.num--
          break
        }
      }
    },
    saveConnecter() {
      if (this.connecter.name == '') {
        this.$toast('请输入联系人名称')
      } else if (this.sex.code == '') {
        this.$toast('请选择性别')
      } else if (this.card.code == '') {
        this.$toast('请选择三名片')
      } else if (this.connecter.position == '') {
        this.$toast('请输入职务')
      } else if (this.connecter.tel == '') {
        this.$toast('请输入电话')
      } else if (this.status.code == '') {
        this.$toast('请选择就职状态')
      } else if (this.salesman.code == '') {
        this.$toast('请选择一个负责人')
      }else {
        const data = {
          tempId: this.connecter.tempId,
          name: this.connecter.name,
          sex: this.sex.code,
          sexTxt: this.sex.txt,
          birthday: this.connecter.birthday,
          card: this.card.code,
          cardTxt: this.card.txt,
          position: this.connecter.position,
          tel: this.connecter.tel,
          status: this.status.code,
          statusTxt: this.status.txt,
          salTxt:this.salesman.txt,
          sal:this.salesman.code
        }
        if (this.connecter.tempId == this.connAdd) {
          this.connecter.tempId = nanoid()
          data.tempId = this.connecter.tempId
          this.connecter.data.push(data)
          this.connecter.num++
        } else {
          for (let index = 0; index < this.connecter.data.length; index++) {
            if (this.connecter.data[index].tempId == this.connecter.tempId) {
              this.connecter.data[index] = data
              break
            }
          }
        }
        this.hideConnecter()
      }
    },
    showConnecter(id) {
      this.connecter.tempId = id
      if (id == this.connAdd) {
        this.card.txt = ''
        this.card.code = ''
        this.status.code = ''
        this.status.txt = ''
        this.sex.txt = ''
        this.sex.code = ''
        this.connecter.name = ''
        this.connecter.position = ''
        this.connecter.tel = ''
        this.connecter.birthday = ''
      } else {
        this.connecter.data.forEach((p) => {
          if (p.tempId == id) {
            this.card.txt = p.cardTxt
            this.card.code = p.card
            this.status.code = p.status
            this.status.txt = p.statusTxt
            this.sex.txt = p.sexTxt
            this.sex.code = p.sex
            this.connecter.name = p.name
            this.connecter.position = p.position
            this.connecter.tel = p.tel
            this.connecter.birthday = p.birthday
            return false
          }
        })
      }
      this.popConn.show = true
    },
    hideConnecter() {
      this.popConn.show = false
    },
    showPopup(operType, showCom) {
      this.pop.showCom = showCom
      this.pop.operType = operType
      this.pop.list = []

      if (this.pop.operType == 0) {
        this.pop.title = '行业'
        this.pop.list = this.trade.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 1) {
        this.pop.title = '企业性质'
        this.pop.list = this.companyType.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 2) {
        this.pop.title = '投资国/地区'
        this.pop.list = this.nationality.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 3) {
        this.pop.title = '信息来源'
        this.pop.list = this.source.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 4) {
        this.pop.title = '三名片'
        this.pop.list = this.card.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 5) {
        this.pop.title = '就职状态'
        this.pop.list = this.status.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 6) {
        this.pop.title = '性别'
        this.pop.list = this.sex.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 7) {
        this.pop.title = '存在相似客户'
        this.pop.list = this.customer.list
        this.pop.confirmTxt = '查看'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 8) {
        this.pop.title = '客户类型'
        this.pop.list = this.custType.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 9) {
        this.pop.title = '负责人'
        this.pop.list = this.salesman.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      }

      this.pop.show = true
    },
    hidePopup() {
      this.pop.show = false
    },
    onPopConfirm(value, index) {
      if (this.pop.operType == 0) {
        this.trade.txt = this.trade.data[index].displayValue
        this.trade.code = this.trade.data[index].code
      } else if (this.pop.operType == 1) {
        this.companyType.txt = this.companyType.data[index].displayValue
        this.companyType.code = this.companyType.data[index].code
      } else if (this.pop.operType == 2) {
        this.nationality.txt = this.nationality.data[index].displayValue
        this.nationality.code = this.nationality.data[index].code
      } else if (this.pop.operType == 3) {
        this.source.txt = this.source.data[index].displayValue
        this.source.code = this.source.data[index].code
      } else if (this.pop.operType == 4) {
        this.card.txt = this.card.data[index].displayValue
        this.card.code = this.card.data[index].code
      } else if (this.pop.operType == 5) {
        this.status.txt = this.status.data[index].displayValue
        this.status.code = this.status.data[index].code
      } else if (this.pop.operType == 6) {
        this.sex.txt = this.sex.data[index].displayValue
        this.sex.code = this.sex.data[index].code
      } else if (this.pop.operType == 7) {
        this.customer.reCustomer.name = this.customer.data[index].customerName
        this.customer.reCustomer.salseName =
          this.customer.data[index].salesmanName
        this.customer.reCustomer.branch = this.customer.data[index].branch
        this.showReCustInfo()
      } else if (this.pop.operType == 8) {
        this.custType.txt = this.custType.data[index].displayValue
        this.custType.code = this.custType.data[index].code
      }else if (this.pop.operType == 9) {
        this.salesman.txt = this.salesman.data[index].salesmanName
        this.salesman.code = this.salesman.data[index].salesmanCode
      }
      if (this.pop.operType != 7) {
        this.hidePopup()
      }
    },
    showReCustInfo() {
      this.popReCust.show = true
    },
    closeReCustInfo() {
      this.popReCust.show = false
    },
    showMap() {
      this.popMap.show = true
    },
    closeMap() {
      this.popMap.show = false
    },
    async searchCustData() {
      if (this.customer.name == '') {
        this.$toast('请输入客户名称')
      } else if (!this.checkCustnameChar()) {
        this.$toast('客户名称不能包含字母和数字')
      } else {
        const res = await customerModel.GetCustomerListByKeyWordUnLimit({
          keyWord: this.customer.name,
        })
        if (res.success) {
          if (res.count > 0) {
            this.customer.data = res.data
            this.customer.list = []
            this.customer.data.forEach((item) => {
              this.customer.list.push(item.customerName)
            })
            this.$toast(
              '已存在与' +
                this.customer.name +
                '名称类似的客户，请点击客户查看信息'
            )
            this.customer.checkPass = false
            this.showPopup(7, this.pickerSet)
          } else {
            this.customer.checkPass = true
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getTrade() {
      const res = await globParamModel.getTrade({})
      if (res.success) {
        this.trade.data = res.data
        this.trade.list = []
        this.trade.data.forEach((item) => {
          this.trade.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getSource() {
      const res = await globParamModel.getSource({})
      if (res.success) {
        this.source.data = res.data
        this.source.list = []
        this.source.data.forEach((item) => {
          this.source.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getNationality() {
      const res = await globParamModel.getNationality({})
      if (res.success) {
        this.nationality.data = res.data
        this.nationality.list = []
        this.nationality.data.forEach((item) => {
          this.nationality.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getCompanyType() {
      const res = await globParamModel.getCompanyType({})
      if (res.success) {
        this.companyType.data = res.data
        this.companyType.list = []
        this.companyType.data.forEach((item) => {
          this.companyType.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getGetSex() {
      const res = await globParamModel.getGetSex({})
      if (res.success) {
        this.sex.data = res.data
        this.sex.list = []
        this.sex.data.forEach((item) => {
          this.sex.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getGetJobStatus() {
      const res = await globParamModel.getGetJobStatus({})
      if (res.success) {
        this.status.data = res.data
        this.status.list = []
        this.status.data.forEach((item) => {
          this.status.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getGetCard() {
      const res = await globParamModel.getGetCard({})
      if (res.success) {
        this.card.data = res.data
        this.card.list = []
        this.card.data.forEach((item) => {
          this.card.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getCustType() {
      const res = await globParamModel.getCustType({})
      if (res.success) {
        this.custType.data = res.data
        this.custType.list = []
        this.custType.data.forEach((item) => {
          this.custType.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getSalesman() {
      const res = await salesmanModel.getSalesman({})
      if (res.success) {
        this.salesman.data = res.data
        this.salesman.list = []
        this.salesman.data.forEach((item) => {
          this.salesman.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async searchSalesman() {
      if (this.salesman.txt == '') {
        this.$toast('请输入销售员名称或编号')
      } else {
        const res = await salesmanModel.getSalesman({
          keyWord: this.salesman.txt,
        })
        if (res.success) {
          this.salesman.data = res.data
          this.salesman.list = []
          this.salesman.data.forEach((item) => {
          this.salesman.list.push(item.salesmanName+'('+item.salesmanCode+')-'+item.branchCode)
        })
          this.showPopup(9, this.pickerSet)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    showheigh() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
    setLocation(address, lng, lat) {
      this.customer.address = address
      this.customer.lng = lng
      this.customer.lat = lat
      this.closeMap()
    },
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState('userAbout', ['salesName']),
    ...mapState('systemAbout', ['approveParam']),
  },
}
</script>
<style scoped>
.btnCenter {
  margin: 0 auto;
  display: block;
  width: 30%;
}
</style>